// @owner ClientPlatform
/* eslint-disable jsx-a11y/label-has-associated-control */

import type {FC, PropsWithChildren} from 'react';
import React, {useState} from 'react';
import {SigninPage, type SwitchToSigninPage} from '../../helpers/pageHelpers';
import {navigateInContext} from '../../../common/location/locationHelpers';
import {pathToRedirectTo} from '../../../helpers/signupHelpers';
import {Text} from '../../../common/components/text';
import {AuthCard} from '../../components/authCard/authCard';
import {Input} from '../../../common/components/input';
import {FullWidthButton} from '../../../common/components/button';
import {requester} from '../../../helpers/requestHelpers';
import {StyledFieldsGroup} from '../../commonSigninStyles';

interface InitSigninProps {
  switchToSigninPage: SwitchToSigninPage;
}

export const InitSignin: FC<PropsWithChildren<InitSigninProps>> = ({switchToSigninPage}) => {
  const [error, setError] = useState('');
  const [companySlug, setCompanySlug] = useState('');
  const [isSending, setIsSending] = useState(false);

  async function signInForCompany() {
    setIsSending(true);
    setError('');

    try {
      const response = await requester.post(`/api/1/signin/${companySlug}`);
      navigateInContext(response.data.redirect_url + pathToRedirectTo());
    } catch (e) {
      if (e.response.status === 404) {
        setError('company_not_found');
      }
    } finally {
      setIsSending(false);
    }
  }

  return (
    <AuthCard
      name="initSignInForm"
      onSubmit={(e) => {
        e.preventDefault();
        signInForCompany();
      }}
    >
      <Text as="h1" variant="title-small-semibold">
        Enter your company&#39;s domain
      </Text>
      <StyledFieldsGroup>
        <Input
          value={companySlug}
          id="company-slug"
          type="text"
          label="Company domain"
          name="slug"
          placeholder="domain"
          onChange={setCompanySlug}
          error={error === 'company_not_found' ? 'Company domain not found' : undefined}
          autoFocus
          required
          suffix=".frontapp.com"
        />
        <FullWidthButton type="submit" disabled={isSending}>
          Continue
        </FullWidthButton>
        <FullWidthButton type="button" variant="tertiary" onClick={() => switchToSigninPage(SigninPage.LOGIN)}>
          Back to login
        </FullWidthButton>
      </StyledFieldsGroup>
    </AuthCard>
  );
};
